module.exports = __webpack_public_path__ + "static/media/04_blanco.bd63cbc2.svg";